






































































import Vue from "vue";
import iwModal from "@/shared/components/Modal.vue";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";

export default Vue.extend({
    components: {
        iwModal: iwModal
    },
    props: {
        isOpen: {
            type: Boolean,
            required: true
        },
        isSaving: {
            type: Boolean,
            required: false,
            default: false
        },
        initialName: {
            type: String,
            required: false,
            default: ""
        }
    },
    data: function() {
        return {
            firstName: "" as string,
            lastName: "" as string,
            firstNameError: null as string | null,
            lastNameError: null as string | null,
            hasAttemptedSubmit: false as boolean
        };
    },
    watch: {
        isOpen: function(newVal) {
            if (newVal) {
                this.firstNameError = null;
                this.lastNameError = null;
                this.hasAttemptedSubmit = false;

                // Always re-seed both fields, even when there is no initial name: the modal is
                // reused across customers (and reopened after a failed save), so leaving the
                // previous record's values in place would let the user save the wrong name.
                const trimmedName = this.initialName ? this.initialName.trim() : "";
                const firstSpaceIndex = trimmedName.indexOf(" ");

                this.firstName = firstSpaceIndex === -1
                    ? trimmedName
                    : trimmedName.substring(0, firstSpaceIndex).trim();
                this.lastName = firstSpaceIndex === -1
                    ? ""
                    : trimmedName.substring(firstSpaceIndex + 1).trim();
            }
        }
    },
    methods: {
        onCloseModal: function() {
            this.$emit("close-modal");
        },
        validate: function() {
            let isValid = true;
            this.firstNameError = null;
            this.lastNameError = null;

            if (!this.firstName || this.firstName.trim() === "") {
                this.firstNameError = i18n.t("field_required").toString();
                isValid = false;
            }
            if (!this.lastName || this.lastName.trim() === "") {
                this.lastNameError = i18n.t("field_required").toString();
                isValid = false;
            }
            return isValid;
        },
        saveName: function() {
            this.hasAttemptedSubmit = true;
            if (this.validate()) {
                const fullName = `${this.firstName.trim()} ${this.lastName.trim()}`;
                this.$emit("save-name", fullName);
            }
        }
    }
});
